module.exports = __webpack_public_path__ + "img/XT-Discos.48d0b877.png";